import React, { useState } from "react";
import { useGoogleLogin } from "@react-oauth/google";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";

export default function GoogleButton({ className = "" }) {
  const { refresh } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const login = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      setLoading(true);
      try {
        const { data } = await api.post("/auth/google/session", {
          access_token: tokenResponse.access_token,
        });
        await refresh();
        if (data.status === "pending") {
          navigate("/awaiting-approval");
        } else {
          navigate("/dashboard");
        }
      } catch (e) {
        console.error("Google login failed on backend:", e);
      } finally {
        setLoading(false);
      }
    },
    onError: (error) => console.error("Google Login Failed:", error),
  });

  return (
    <button
      type="button"
      onClick={() => login()}
      disabled={loading}
      data-testid="google-login-button"
      className={`w-full h-11 inline-flex items-center justify-center gap-3 border border-border bg-white hover:bg-accent transition-colors text-[14px] font-semibold text-foreground ${loading ? "opacity-50 cursor-not-allowed" : ""} ${className}`}
    >
      <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
        <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.8 32.5 29.3 35.8 24 35.8c-6.5 0-11.8-5.3-11.8-11.8S17.5 12.2 24 12.2c3 0 5.8 1.1 7.9 3L37.6 9.5C34 6.3 29.3 4.4 24 4.4 13.2 4.4 4.4 13.2 4.4 24S13.2 43.6 24 43.6 43.6 34.8 43.6 24c0-1.2-.1-2.3-.4-3.5z"/>
        <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.6 15.9 19 13 24 13c3 0 5.8 1.1 7.9 3l5.7-5.7C34 6.3 29.3 4.4 24 4.4 16.3 4.4 9.7 8.8 6.3 14.7z"/>
        <path fill="#4CAF50" d="M24 43.6c5.2 0 10-2 13.5-5.2l-6.2-5.2C29.1 34.8 26.7 35.8 24 35.8c-5.3 0-9.8-3.3-11.3-7.9L6 32.6C9.4 38.8 16.1 43.6 24 43.6z"/>
        <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.7 2-2 3.7-3.7 4.9l6.2 5.2C40.8 34.9 44 29.9 44 24c0-1.2-.1-2.3-.4-3.5z"/>
      </svg>
      <span>{loading ? "Signing in..." : "Continue with Google"}</span>
    </button>
  );
}
